// import lottie from 'lottie-web';
import animation from '@CS/utils/Lottie';
import { useRef, useEffect } from 'react';
import type { AnimationConfig } from '@CS/utils/Lottie';
import AnimationContainer from './LottieAnimation.styles';

type LottieAnimationProps = {
  animationData?: Record<string, unknown>;
  data?: AnimationConfig;
  path?: string;
};

export const LottieAnimation = ({
  data,
  animationData,
  path
}: LottieAnimationProps) => {
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = animationContainer.current as Element;

    const anim = animation({
      ...(animationData && { animationData }),
      ...(path && { path }),
      ...(data && data),
      container
    });

    anim.setSpeed(2.5);
    // return () => lottie.destroy();
  }, []);

  return <AnimationContainer ref={animationContainer} />;
};
